export default "__VITE_ASSET__Bd1_BZIe__"